import { MutableRefObject, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { canUseSsoSession, clearSsoHint, SESSION_GONE_ERRORS } from './SessionTransfer.utils';
import { SilentAuthError } from './SessionTransfer.types';

export const useSessionIdentitySync = (didFetchFreshSession?: MutableRefObject<boolean>) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const hasRevalidated = useRef(false);

  useEffect(() => {
    if (isLoading || !isAuthenticated || hasRevalidated.current) return;
    if (didFetchFreshSession?.current || !canUseSsoSession()) return;
    hasRevalidated.current = true;

    getAccessTokenSilently({ cacheMode: 'off' }).catch((error: SilentAuthError) => {
      if (!SESSION_GONE_ERRORS.includes(error?.error ?? '')) return;
      clearSsoHint();
      logout({ openUrl: false });
    });
  }, [isLoading, isAuthenticated, getAccessTokenSilently, logout, didFetchFreshSession]);
};
